/* eslint-disable import/prefer-default-export */

const registerSegmentAnalytics = (user) => {
  const integrationSettings = {
    integrations: {
      All: false,
      FullStory: true,
    },
  };
  window.analytics.page('', '', {}, integrationSettings);
  window.analytics.identify(user.user_id, user, integrationSettings);
};

export { registerSegmentAnalytics };
